import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/el.ts
var add = "Προσθήκη";
var remove = "Αφαίρεση";
var removeAll = "Αφαίρεση όλων";
var incomplete = "Λυπούμαστε, υπάρχουν πεδία που δεν έχουν συμπληρωθεί σωστά.";
var submit = "Υποβολή";
var noFiles = "Κανένα αρχείο δεν έχει επιλεγεί";
var moveUp = "Προς τα επάνω";
var moveDown = "Προς τα κάτω";
var isLoading = "Φορτώνει...";
var loadMore = "Φόρτωση περισσότερων";
var next = "Επόμενη";
var prev = "Προηγούμενο";
var addAllValues = "Προσθήκη όλων των τιμών";
var addSelectedValues = "Προσθήκη επιλεγμένων τιμών";
var removeAllValues = "Κατάργηση όλων των τιμών";
var removeSelectedValues = "Αφαίρεση επιλεγμένων τιμών";
var chooseDate = "Επιλέξτε ημερομηνία";
var changeDate = "Αλλαγή ημερομηνίας";
var close = "Κλείσιμο";
var open = "Ανοιχτό";
var accepted = function({
  name
}) {
  return `Παρακαλώ αποδεχτείτε το ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} πρέπει να είναι μετά της ${date(args[0])}.`;
  }
  return `${sentence(name)} πρέπει να είναι στο μέλλον.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} μπορεί να περιέχει μόνο αλφαβητικούς χαρακτήρες.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} μπορεί να περιέχει μόνο γράμματα και αριθμούς.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} μπορεί να περιέχει μόνο γράμματα και κενά.`;
};
var contains_alpha = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να περιέχει αλφαβητικούς χαρακτήρες.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να περιέχει γράμματα ή αριθμούς.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} πρέπει να περιέχει γράμματα ή κενά.`;
};
var contains_symbol = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να περιέχει το σύμβολο.`;
};
var contains_uppercase = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να περιέχει κεφαλαία γράμματα.`;
};
var contains_lowercase = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να περιέχει πεζά γράμματα.`;
};
var contains_numeric = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να περιέχει αριθμούς.`;
};
var symbol = function({
  name
}) {
  return `Το ${sentence(name)} πρέπει να είναι ένα σύμβολο.`;
};
var uppercase = function({
  name
}) {
  return `Το ${sentence(name)} μπορεί να περιέχει μόνο κεφαλαία γράμματα.`;
};
var lowercase = function({
  name
}) {
  return `Το ${sentence(name)} μπορεί να περιέχει μόνο πεζά γράμματα.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} πρέπει να είναι πριν της ${date(args[0])}.`;
  }
  return `${sentence(name)} πρέπει να είναι στο παρελθόν.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Αυτό το πεδίο έχει ρυθμιστεί λανθασμένα και δεν μπορεί να υποβληθεί.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} πρέπει να είναι μεταξύ ${a} και ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} δεν ταιριάζει.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} δεν είναι έγυρη ημερομηνία, παρακαλώ ακολουθήστε την διαμόρφωση ${args[0]}`;
  }
  return "Αυτό το πεδίο έχει ρυθμιστεί λανθασμένα και δεν μπορεί να υποβληθεί";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} πρέπει να είναι μεταξύ ${date(args[0])} και ${date(args[1])}`;
};
var email = "Παρακαλώ πληκτρολογήστε μια έγκυρη email διεύθυνση. ";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} δεν καταλήγει με ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} δεν είναι μια επιτρεπτή τιμή.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} πρέπει να είναι τουλάχιστον ενός χαρακτήρα.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} πρέπει να είναι λιγότεροι ή ίσοι με ${max2} χαρακτήρες.`;
  }
  if (min2 === max2) {
    return `Το ${sentence(name)} θα πρέπει να έχει μήκος ${max2} χαρακτήρες.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} πρέπει να είναι περισσότεροι ή ίσοι με ${min2} χαρακτήρες.`;
  }
  return `${sentence(name)} πρέπει να είναι μεταξύ ${min2} και ${max2} χαρακτήρες.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} δεν είναι μια επιτρεπτή τιμή.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Δεν μπορεί να έχει παραπάνω από ${args[0]} ${name}.`;
  }
  return `${sentence(name)} πρέπει αν είναι λιγότερο ή ίσο με το ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Δεν επιτρέπονται αρχεία.";
  }
  return `${sentence(name)} πρέπει να είναι τύπου: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Δεν μπορεί να είναι λιγότερο από ${args[0]} ${name}.`;
  }
  return `${sentence(name)} πρέπει να είναι τουλάχιστον ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” δεν είναι μια επιτρεπτή ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} πρέπει να είναι αριθμός.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" ή ")} απαιτείται.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} είναι υποχρεωτικό.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} δεν αρχίζει με ${list(args)}.`;
};
var url = function() {
  return `Παρακαλώ εισάγετε ένα έγκυρο URL.`;
};
var invalidDate = "Η επιλεγμένη ημερομηνία δεν είναι έγκυρη.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var el_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, el_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=el.mjs.map